import { axios } from '@utils';
import initializeZendesk from '@services/zendesk_initializer';

class ZendeskService {
  constructor() {
    if (this.instance) {
      return this.instance; // eslint-disable-line no-constructor-return
    }
    this.instance = this;

    if (window.env.AUTHORIZED) {
      if (document.readyState === 'complete' || document.readyState === 'interactive') {
        setTimeout(() => this.loadScript(), 1);
      } else {
        document.addEventListener('DOMContentLoaded', () => this.loadScript());
      }
    }
  }

  // eslint-disable-next-line class-methods-use-this
  async loadScript() {
    if (!window.zE) initializeZendesk();
  }

  // eslint-disable-next-line class-methods-use-this
  async waitForZSC() {
    return new Promise((resolve) => {
      const checkZDC = () => {
        setTimeout(() => {
          if (window.zE) {
            resolve();
          } else {
            checkZDC();
          }
        }, 300);
      };
      if (window.zE) {
        resolve();
      } else {
        checkZDC();
      }
    });
  }

  async open() {
    await this.waitForZSC();

    window.zE('messenger', 'show');
    window.zE('messenger', 'open');
  }

  async close() {
    await this.waitForZSC();

    window.zE('messenger', 'close');
    window.zE('messenger', 'hide');
  }

  async identifyUser() {
    await this.waitForZSC();

    window.zE(
      'messenger',
      'loginUser',
      (callback) => {
        axios.post('/api/v1/zendesk/jwt').then(({ data }) => callback(data.token));
      },
      (error) => {
        if (!error) axios.post('/api/v1/zendesk/sync');
      },
    );
  }
}

const zendesk = new ZendeskService();

export default zendesk;
